import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import App from './App';
import './App.scss';
import ScrollToTop from './ScrollToTop';
import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

// --- Google Analytics setup ---
ReactGA.initialize('G-C2MW3Y8GL7');

// --- Sentry v8 setup ---
Sentry.init({
  dsn: 'https://6827f35127f97019b507abfeadcf82a9@o4510018518188032.ingest.us.sentry.io/4510018518908928',
  integrations: [
    Sentry.browserTracingIntegration(), // performance monitoring
    // Optional: record user sessions & clicks
    // Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0, // keep high in dev; lower in prod (e.g. 0.2)
  // replaysSessionSampleRate: 0.1, // optional if using Replay
  // replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
});

// Track GA pageviews
function GAListener() {
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GAListener />
      <ScrollToTop />
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>
);